import {
  IStoreDepositPage,
  IStoreDepositParams,
  IStoreDepositAccount,
  IStoreDepositAllowedStores,
  IUpdateDepositAccountPayload,
  IUpdateDepositNsuPayload,
  IUpdateDepositNsuResult,
} from "src/@types/store-deposit-maintenance";

import { apiSlice } from "./http";
import { toQueryParams } from "@/utils/to-query-params";

const BASE_URL = "/store-deposit-maintenance";

export const storeDepositMaintenanceApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getStoreDeposits: builder.query<IStoreDepositPage, IStoreDepositParams>({
      query: (filters: IStoreDepositParams) => ({
        url: `${BASE_URL}?${toQueryParams(filters)}`,
        method: "GET",
      }),
    }),
    getStoreDepositAccounts: builder.query<IStoreDepositAccount[], number>({
      query: (storeCode: number) => ({
        url: `${BASE_URL}/accounts?${toQueryParams({ storeCode })}`,
        method: "GET",
      }),
    }),
    getStoreDepositAllowedStores: builder.query<
      IStoreDepositAllowedStores,
      void
    >({
      query: () => ({
        url: `${BASE_URL}/allowed-stores`,
        method: "GET",
      }),
    }),
    updateStoreDepositNsu: builder.mutation<
      IUpdateDepositNsuResult,
      IUpdateDepositNsuPayload
    >({
      query: (payload: IUpdateDepositNsuPayload) => ({
        url: `${BASE_URL}/nsu`,
        method: "PUT",
        body: payload,
      }),
    }),
    updateStoreDepositAccount: builder.mutation<
      void,
      IUpdateDepositAccountPayload
    >({
      query: (payload: IUpdateDepositAccountPayload) => ({
        url: `${BASE_URL}/account`,
        method: "PUT",
        body: payload,
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetStoreDepositsQuery,
  useGetStoreDepositAccountsQuery,
  useGetStoreDepositAllowedStoresQuery,
  useUpdateStoreDepositNsuMutation,
  useUpdateStoreDepositAccountMutation,
} = storeDepositMaintenanceApi;
